exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chartDiv {\r\n    width: 100%;\r\n    height: 500px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/charts/barCharts/basicBarChart/basicBarChart.component.css
// module id = ../../../../../app/shared/components/charts/barCharts/basicBarChart/basicBarChart.component.css
// module chunks = main